import script from "./MallInquiryWritePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallInquiryWritePage.vue?vue&type=script&setup=true&lang=ts"

import "./MallInquiryWritePage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__